import React from 'react'
import './styles.scss'

import Header from '../Header'
import Footer from '../../Shared/Footer'
import PropTypes from 'prop-types'

const Layout = ({ children }) => {
  return (
    <div className="default-layout main-wrapper">
      <Header/>
      <main>{children}</main>
      <Footer/>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
